/* eslint-disable @typescript-eslint/no-explicit-any */
import { render, h } from "vue";
import getPrivateKeyVue from "./getPrivateKey.vue";
import { getUserInfo } from "@/api/login";
import { useStore } from "@/store";
import { getKeyChain } from "@/utils/hooks/systemKeychain";

const IS_ELECTRON = process.env.IS_ELECTRON;

export const getPrivateKey = async (
  resetPassword?: boolean,
  color = "#4749ad",
  onPassword?: (password: string) => void
): Promise<string> => {
  const res = await getUserInfo();
  const store = useStore() as any;
  store.commit("user/setUserInfo", res);
  const userNo = res.userNo;
  // 客户端：有 keytar 则直接返回私钥，无需弹窗、无需 session
  if (IS_ELECTRON) {
    const keyChain = await getKeyChain(userNo);
    if (keyChain) {
      log.info("keychain exists, returning private key", keyChain !== null);
      return Promise.resolve(keyChain.privateKey);
    }
  }

  // 无 keytar（客户端）或网页端：弹窗输入授权密码。网页端不读 session，靠浏览器密码管理器保存/填充。
  return new Promise<string>((resolve, reject) => {
    const container = document.createElement("div");
    render(
      h(getPrivateKeyVue, {
        resetPassword: resetPassword || false,
        color,
        onClose: () => {
          render(null, container);
          container.remove();
          reject();
        },
        onPassword: (pwd: string) => {
          if (onPassword) onPassword(pwd);
        },
        onScrect: (privatekey: string) => {
          render(null, container);
          container.remove();
          log.info("privatekey success");
          resolve(privatekey);
        },
      }),
      container
    );
    document.body.appendChild(container);
  });
};
